import { render, staticRenderFns } from "./60.vue?vue&type=template&id=b21023a4&scoped=true&"
import script from "./60.vue?vue&type=script&lang=js&"
export * from "./60.vue?vue&type=script&lang=js&"
import style0 from "./60.vue?vue&type=style&index=0&id=b21023a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21023a4",
  null
  
)

export default component.exports